import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { getOrgBackend } from "../../../app/backend";

export function useRemoteFetchStoredScheduleColleagues() {
  return useRemoteQuery<string[]>({
    queryKey: ["fetch-stored-schedule-colleagues"],
    url: `${getOrgBackend()}/stored-users-in-booking-calendar`
  });
}
